// extracted by mini-css-extract-plugin
export default {"container":"InactivityCounter_container__P5vk-","popup":"InactivityCounter_popup__h-iMU"};